import { Card, Typography, Box, Chip, IconButton } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Edit, Delete } from "@mui/icons-material";
import { motion } from "motion/react";
import { useEditMode } from "../context/EditModeContext";

interface CertificationCardProps {
  name: string;
  issuer: string;
  year: string;
  onEdit?: () => void;
  onDelete?: () => void;
}

export default function CertificationCard({
  name,
  issuer,
  year,
  onEdit,
  onDelete,
}: CertificationCardProps) {
  const { isEditMode } = useEditMode();

  return (
    <motion.div
      whileHover={{ scale: 1.03, boxShadow: "0px 8px 20px rgba(0,0,0,0.15)" }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      style={{ height: "100%" }}
    >
      <Card sx={{ position: "relative", p: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        {isEditMode && (
          <Box sx={{ position: "absolute", top: 8, right: 8, display: "flex", gap: 1 }}>
            {onEdit && (
              <IconButton size="small" onClick={onEdit}>
                <Edit fontSize="small" />
              </IconButton>
            )}
            {onDelete && (
              <IconButton size="small" onClick={onDelete}>
                <Delete fontSize="small" color="error" />
              </IconButton>
            )}
          </Box>
        )}

        <Box>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <VerifiedIcon color="success" />
            <Typography variant="h6">{name}</Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            {issuer} - {year}
          </Typography>
        </Box>

        <Chip label="Certified" color="success" size="small" sx={{ mt: 2, alignSelf: "flex-start" }} />
      </Card>
    </motion.div>
  );
}
